import React from "react";

const LoadingPage = () => {
  return (
    <div className='flex min-h-screen items-center justify-center bg-slate-950 text-white'>
      <div className='w-full max-w-md px-5 text-center'>
        <div className='mx-auto mb-4 h-16 w-16 animate-spin rounded-full border-4 border-slate-500 border-t-[#1739bd]' role='status'>
          <span className='sr-only'>Loading...</span>
        </div>
        <h1 className='text-3xl font-bold'>Loading...</h1>
        <p className='mt-2 text-sm text-slate-300'>Your journey awaits. Please hold on!</p>
        <div className='mx-auto mt-5 h-2.5 w-full max-w-xs overflow-hidden rounded-full bg-slate-700'>
          <div
            className='h-full animate-pulse rounded-full bg-[#1739bd]'
            role='progressbar'
            style={{ width: "75%" }}
            aria-valuenow="75"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
